import { Console } from "models/console";
export const console = new Console();
